export default {
    dataDimension: true,
};



/** WEBPACK FOOTER **
 ** ./src/model/config/model-defaults/organisationUnitGroupSet.js
 **/